const Graphics = ({ graphics }: { graphics: any }) => {
  console.log(graphics);
  return (
    <div className="p-2 rounded-lg border border-[#000] border-opacity-30 space-y-1">
      <h6 className="text-[#0D0D0D80] font-medium leading-[120%] text-[13px] tracking-[0%]">
        --
      </h6>
      <h6 className="text-[#0D0D0D] text-[11px] leading-[120%] tracking-[0%]">
        --
      </h6>
    </div>
  );
};

export default Graphics;
